<template>
  <div class="table">
    <div class="container">
      <div>
        <p class="icon-jujue closeBtn" @click="routerBack"></p>
      </div>
      <div class="handle-box">
        <el-form :model="queryCondition" ref="queryCondition" :label-position="labelPosition" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Facility名称" prop="facilityName">
                      <el-input v-model="queryCondition.facilityName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="供应商集团名称" prop="supplierGroupName">
                      <el-input v-model="queryCondition.supplierGroupName" clearable style="width:100%"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category2" prop="category2CodeList"> 
                      <el-select v-model="queryCondition.category2CodeList" @change="changeCategory2" multiple  clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in categoryList2" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3CodeList">
                      <el-select v-model="queryCondition.category3CodeList" clearable multiple filterable placeholder="请选择(支持多选)" style="width:100%">
                         <el-option :key="index" v-for="(item,index) in categoryList3" :label="item.name" :value="item.code"></el-option>
                      </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="状态" prop="status">
                      <el-select v-model="queryCondition.status" clearable  filterable placeholder="请选择" style="width:100%">
                         <el-option :key="index" v-for="(item,index) in statusOptions" :label="item.label" :value="item.value"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="queryData" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
          
        </el-form>
      </div>
      <!-- <el-row class="action-btn-row" type="flex">
        <el-button size="mini" class="btn" type="primary" @click="onCreate">确认发起评分任务</el-button>
      </el-row> -->
      <el-form ref="formInline" :inline="true" :model="formInline" class="demo-form-inline" :rules="rules">
        <el-form-item label="">
          <el-button size="mini" class="btn" type="primary" @click="onCreate">确认发起评分任务</el-button>
        </el-form-item>
        <el-form-item label="供应商自评截止日期" prop="endDate">
          <el-date-picker v-model="formInline.endDate" value-format="yyyy-MM-dd" type="date" placeholder="请输入日期"> </el-date-picker>
        </el-form-item>
      </el-form>

      <el-table ref="plxTable" border  :cell-class-name="changeColor" :data="tableData" @selection-change="selectionChange" max-height="500" show-overflow="ellipsis" highlight-current-row>
        <el-table-column align="center" type="selection" width="80" :selectable="isSelect"/>
        <el-table-column align="center" label="Facility Code" min-width="140" prop="code"></el-table-column>
        <el-table-column align="center" label="Facility名字" min-width="140" prop="name">
            <template v-slot="scope">
                <el-button type="text" @click="onDetail(scope.row)">{{scope.row.name}}</el-button>
            </template>
        </el-table-column>
        <el-table-column align="center" label="Category2" min-width="100" prop="category2Name"></el-table-column>
        <el-table-column align="center" label="供应商集团编码" min-width="140" prop="groupCode"></el-table-column>
        <el-table-column align="center" label="供应商集团名称" min-width="140" prop="groupName"></el-table-column>
        <el-table-column align="center" label="状态" min-width="100" prop="statusView"></el-table-column>
        <el-table-column align="center" label="更新人" min-width="120" prop="updateByName"></el-table-column>
        <el-table-column align="center" label="更新日期" min-width="100" prop="updateDate"></el-table-column>
        <el-table-column align="center" label="创建日期" min-width="120" prop="createDate"></el-table-column>
        <el-table-column align="center" label="最新供货月份" min-width="120" prop="lastSuppliedMonth"></el-table-column>
        <el-table-column align="center" label="最新月供货量" min-width="120" prop="lastSuppliedQty"></el-table-column>
      </el-table>
    </div>
    <!-- <el-dialog :visible.sync="showDetailDialog" append-to-body width="80%" :close-on-click-modal="false" @close="closeDialog">
      <detailDialog v-if="showDetailDialog" :formData="formData"></detailDialog>
    </el-dialog> -->
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import store from '@/store/index'
import ratingTask from "@/api/AAA/ratingTask.js";
import apiService  from "@/api/AAA/index.js";
import QBRApi from "@/api/QBR/index";


export default {
  name: '',
  components: {
    IcSelect,
    // detailDialog
  },
  data() {
    return {
      rules: {
          endDate: [
            { required: true, message: '请选择截止日期', trigger: 'change' }
          ]
        },
      formInline:{
        endDate:"",
      },
      statusOptions:[{
        label:"新增",
        value:"NEW"
      },{
        label:"启用",
        value:"ACTIVE"
      },{
        label:"禁用",
        value:"INACTIVE"
      }],
      multipleSelection:[],
      categoryList2: [],
      categoryList3: [],
      queryCondition: {
        category2CodeList: [],
        category3CodeList: [],
        facilityName: "",
        status: "",
        supplierGroupName: ""
      },
      isShow: false,
      showDetailDialog:false,
      tableData: [],
      formData:null,
    }
  },
  created() {
    this.queryData();
    this.getCategory2Lists()
    this.getCategory3Lists()
  },
  methods: {
    queryData() {
      ratingTask.getFacilityList(this.queryCondition).then((res)=>{
        this.tableData=res.resultData
        this.$nextTick(()=>{
          for(let i=0;i<this.tableData.length;i++){
            if(!this.tableData[i].isGenerate){
              this.$refs.plxTable.toggleRowSelection(
                this.tableData[i],
                true
              );
            }
          }
        })
      })
    },
    onDetail(row){
      this.showDetailDialog=true
      this.formData=JSON.stringify(row)
    },
    selectionChange(val){
      this.multipleSelection=val
    },
    onReset() {
      this.$refs['queryCondition'].resetFields();
      this.queryCondition={
        category2CodeList: [],
        category3CodeList: [],
        facilityName: "",
        status: "",
        supplierGroupName: ""
      },
      this.queryData()
    },
    isSelect(row,index){
      if(row.isGenerate){
        return false
      }else{
        return true
      }
    },
    onCreate() {
      let isCreate=this.multipleSelection.some((v)=>{
        return !v.isCanAudit
      })
      if(isCreate){ 
        this.$message.error('您无权限操作数据')
      }else{
        this.$refs['formInline'].validate((valid) => {
          if (valid) {
            let idList=[]
            this.multipleSelection.forEach((v)=>{
              idList.push(v.tmQspiFacilityId)
            })
            let params={
              closingDate:this.formInline.endDate+' 23:59:59',
              idList:idList
            }
            console.log("🚀 ~ file: initiateScoringTask.vue:210 ~ this.$refs['formInline'].validate ~ params:", params)
            ratingTask.saveFacilityList(params).then((res)=>{
              if(res.code==200){
                this.$message.success("发起成功")
                this.queryData()
              }else{
                this.$message.error(res.msg)
              }
            })
          } else {
            console.log('error submit!!');
            return false;
          }
        });
      }
    },
    onDel() {

    },
    changeColor({ row, column, rowIndex, columnIndex }){
      if(row.isGtSixMonth){
        return "gray_class"
      }else if(row.isGtSixMonth==null){
        // return "yellow_class"
      }else if(row.isGtSixMonth==false){
        return "yellow_class"
      }
    },
    routerBack() {
      this.$router.back();
    },
    getCategory2Lists() {
      var param = {
        categoryLevel: '2',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList2 = res.data
      });
    },
    getCategory3Lists() {
      var param = {
        categoryLevel: '3',
      }
      QBRApi.getCategoryLists(param).then(res => {
        this.categoryList3 = res.data
      });
    },
  },
}
</script>
<style scoped >
</style>
